module.exports = __webpack_public_path__ + "static/media/2021_S_CP_RTMax18_Indus_Supafil_HD_01 (1).65d05a63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2021_S_CP_RTMax18_Indus_Supafil_HD_01 (1).jpg
// module id = 1160
// module chunks = 0